import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  Observable,
  map,
} from 'rxjs';
import { ConfigurationService } from '@sondermind/configuration';
import { IProviderPreview, IProviderSoonestAvailabilityApiListing } from '@sondermind/features/provider-listing-card';
import { HttpService } from '@sondermind/http';
import { IAPIListResponse, IAPIListRequestOptions } from '@sondermind/utilities/models-http';

@Injectable({
  providedIn: 'root'
})
export class ProviderDirectoryHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService
  ) { }

  list$(options: Partial<IAPIListRequestOptions> = {}): Observable<IAPIListResponse<IProviderPreview>> {
    const newOpts = options;

    if (!options.page) {
      newOpts.page = 'disabled';
    }

    const params = this.http.generateListParams(newOpts);

    return this.http.get<IAPIListResponse<IProviderPreview>>(this.indexUrl, params).pipe(
      map((response) => ({ ...response })),
      this.http.handleHttpErrorStrict()
    );
  }

  getSoonestAvailableSessions$(providerIds: number[]): Observable<IAPIListResponse<IProviderSoonestAvailabilityApiListing>> {
    let params = new HttpParams();

    providerIds.forEach((providerId) => {
      params = params.append('persona_provider_ids[]', providerId);
    });

    const url = `${this.baseUrl}/scheduling/soonest_available_sessions`;
    return this.http.get<IAPIListResponse<IProviderSoonestAvailabilityApiListing>>(url, params)
      .pipe(
        this.http.handleHttpErrorStrict()
      );
  }

  get baseUrl(): string {
    return this.configurationService.env.svcBase;
  }

  get indexUrl(): string {
    return `${this.baseUrl}/provider_profiles/provider_directory_view`;
  }
}
